module.exports = __webpack_public_path__ + "img/big_11B03_orange.c803cb4a.png";